import {Component, OnInit, Input, ViewChild, ElementRef, OnDestroy, Output, EventEmitter} from "@angular/core";
import {interval} from "rxjs";
import * as Communication from "../communication/index";
import {Router, ActivatedRoute} from "@angular/router";
import {Config} from "../../environments/environment";
import {NavigationService} from "../shared/common/NavigationEventService";
import {NavigationEvent} from "../shared/common/NavigationEvent";
import { Subscription } from 'rxjs';
import {Location} from "@angular/common";
import {ToolbarService} from "../shared/common/ToolbarEventService";
import {NotificationService} from "../shared/common/NotificationService";
import { FormsModule, ReactiveFormsModule, FormGroup, FormControl, FormBuilder, Validators  } from '@angular/forms';
import {ToolbarEventPageEnum, ToolbarEvent} from "../shared/common/ToolbarEvent";
import {Authorization} from "../shared/authorization/authorization.component";
import {TranslateService} from '@ngx-translate/core';
import {NgForm} from '@angular/forms';
import {subscribeOn} from "rxjs";


declare var $:any;
declare var swal: any;
declare var formatter: any;

/**
 * This class represents the lazy loaded AccountComponent.
 */
@Component({
    selector: 'sd-payment',
    templateUrl: 'payment.component.html',
    styleUrls: ['payment.component.css'],
    providers: [Communication.JobsService, Communication.DocumentsService, Communication.RecipientRequestService, Communication.SubscriptionService, Communication.PaymentService,],
    standalone: false
})
export class PaymentComponent implements OnInit, OnDestroy {
  //@ViewChild('threedsframe') iframe: ElementRef;

  timerSubscription:Subscription=null;
  subscriptions:Subscription[] = [];

  thePayment:any={};
  paymentGroup:string="Company";

  @Input() action:any = {}; // 'add', 'update' for Subscription
  @Input() plan:any = {}; // data coming from upgrade component
  isCardNoValid:boolean=true;
  isMMYYValid:boolean=true;
  isCouponValid:boolean=true;
  theUser:Communication.UserInfo;
  price:number;
  discountCoupon:string;
  procesStatus:string = "continue";
  isUserDataFetched:boolean = false;

  constructor(private jobsApi:Communication.JobsService,
              private documentsApi:Communication.DocumentsService,
              private usersApi:Communication.UsersService,
              private paymentApi:Communication.PaymentService,
              private subscriptionsApi:Communication.SubscriptionService,
              private activatedRoute:ActivatedRoute,
              private router:Router,
              private navigationService:NavigationService,
              private toolbarService: ToolbarService,
              private location:Location,
              private authorization: Authorization,
              private notificationService: NotificationService,
              public translate: TranslateService)
  {





  }


  ngOnInit() {

    if (!this.authorization.authenticated()) {
      this.router.navigate(['/']);
    } else {
      console.log("action: " + this.action);

      //this.InitFormFieldFormats();
      this.InitModel();
      this.GetUser();

      let _thisOnMessage = this;
      window.onmessage = function (event:any) {
        // For Chrome, the origin property is in the event.originalEvent object.
        let origin = event.origin || event.origin;

        //Do we trust the sender of this message? test sender!
        //Config.WEBSERVICEURL + "/payment/callback/iyzico"
        if (origin !== Config.WEBSITE && origin !== "https://securewebserver.net" && origin !== "http://imzayerilocal:8080" && origin !== "https://localhost")
        {
          console.log("UNWANTED ORIGIN:: ",origin);
          return; // unwanted origin
        }
        else {
          console.log("data origin " + origin + " paymentId "+ event.data);

          _thisOnMessage.paymentApi.paymentsIdGet(_thisOnMessage.authorization.getAccessToken(), event.data.toString()).subscribe(
            (payment:Communication.Payment) => {
              console.log("status: " + payment.status + "\nprice: " + payment.price + "\npaid price: " + payment.iyzicoPaidPrice +"\nplan: "+ payment.plan.name +"\nperiod: "+ payment.period +"\nerr group: "+ payment.iyzicoErrorGroup +"\nerr code: "+ payment.iyzicoErrorCode +"\nerr: "+ payment.iyzicoErrorMessage );

              $("#modal_threeds").modal('hide'); //open add modal

              if(payment.status == "failure") {
                _thisOnMessage.notificationService.showPaymentErrorAlert(payment.iyzicoErrorMessage, function (isConfirmed: boolean)
                {
                  if (isConfirmed)
                    $("#modal_payment").modal('show'); //failure: open modal
                })
              }
              else {
                _thisOnMessage.procesStatus = "finished";
                _thisOnMessage.isUserDataFetched = false;
                _thisOnMessage.GetUser();

                let timerSubscription = interval(500).subscribe(x => {
                  if(_thisOnMessage.isUserDataFetched)
                  {
                    if (timerSubscription != null)
                      timerSubscription.unsubscribe();

                    //write to localStorage
                    let subscription = _thisOnMessage.theUser.subscription;
                    subscription.plan = payment.plan;
                    subscription.invoiceAddress = payment.invoiceAddress;
                    subscription.invoiceCity = payment.invoiceCity;
                    subscription.invoiceCountry = payment.invoiceCountry;
                    subscription.invoiceProvince = payment.invoiceProvince;
                    subscription.period = payment.period;
                    subscription.cardLastNo = _thisOnMessage.thePayment.cardNo.substring(_thisOnMessage.thePayment.cardNo.length-4, _thisOnMessage.thePayment.cardNo.length);
                    //subscription.planStartDate = payment.iyzicoSystemTime;

                    _thisOnMessage.authorization.setUserAccount(subscription, _thisOnMessage.authorization.userAccount.language);

                    //wait to navigate result page
                    setTimeout(() => {
                      let action = _thisOnMessage.action;
                      if (action == "upgrade") action = "register";

                      _thisOnMessage.router.navigate(['/result'], { queryParams: { action: action, plan: payment.plan.name, period: payment.period}});
                    }, 25);

                  }
                });


              }

            }, //Bind to view
            (err:any) => {
              // Log errors if any
              console.log(err);
              _thisOnMessage.notificationService.displayError(err);
            });
        }
      };
    }
  }


  GetUser(){

    this.subscriptions.push(this.usersApi.usersGet(this.authorization.getAccessToken()).subscribe(
      (user:Communication.UserInfo) => {
        console.log(user);
        this.theUser = user;

        if(this.procesStatus == "continue") {
          this.UpdatedModel();
        } else {
          this.isUserDataFetched = true;
        }

      }, //Bind to view
      (err:any) => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }


  InitModel(){
    let company = { title: "",  taxOffice: "",  taxNo:  ""  };
    let individual = { name: "", citizenId: "" };

    this.thePayment = {
      nameOnCard: "",
      cardNo: "",
      mm: "",
      yy: "",
      cvc: "",
      company: company ,
      individual: individual,
      address: "",
      city: "",
      province: "",
      zipCode: "",
      discountCoupon: ""
    };
  }


  //after user data fetch, we assign it to model
  UpdatedModel(){
    let company = {
      title:  this.theUser.subscription.invoiceTitle || "",
      taxOffice: this.theUser.subscription.invoiceTaxOffice || "",
      taxNo: this.theUser.subscription.invoiceTaxNo || ""
    };
    let individual = {
      name: this.theUser.subscription.invoiceName || "",
      citizenId: this.theUser.subscription.invoiceCitizenId || "",
    };

    this.thePayment = {
      nameOnCard: this.theUser.subscription.invoiceName || "",
      cardNo: "",
      mm: "",
      yy: "",
      cvc: "",
      company: company,
      individual: individual,
      address: this.theUser.subscription.invoiceAddress || "",
      city: this.theUser.subscription.invoiceCity || "",
      province: this.theUser.subscription.invoiceProvince || "",
      zipCode: this.theUser.subscription.invoiceZip || "",
      discountCoupon: ""
    };
  }




  checkMMYY(mm:string, isMMValid:boolean, yy:string, isYYValid:boolean){
    console.log("mmyy " + " " + mm +" "+ yy);

    if (!isMMValid || !isYYValid) {
      this.isMMYYValid = false;
    }else {

      let month = Number(mm);
      let year = Number("20" + yy);
      let currentMonth = new Date().getMonth() + 1;
      let currentYear = new Date().getFullYear();

      if (year < currentYear || year > currentYear + 10 || (year == currentYear && month < currentMonth)){
        this.isMMYYValid = false;
        console.log("MMYY Invalid");
      }
      else {
        this.isMMYYValid = true;
      }
    }
  }


  checkCardNo(cardNumber:string, isCardNumberValid:boolean) {
    if (isCardNumberValid) {
      console.log("regex valid.");
      //else check with Luhn algorithm
      this.luhnCheck(cardNumber);
    } else {
      this.isCardNoValid = false;
    }
  }

  checkCoupon(discountCoupon:string, isDiscountCouponValid:boolean){
    if (isDiscountCouponValid) {
      console.log("DiscountCoupon is valid.");
      if(discountCoupon == ''){
        this.price = null;
      } else {
        this.getCoupon(discountCoupon);
      }
    } else {
      this.price = null;
      this.isCouponValid = false;
      console.log("DiscountCoupon is not valid.", this.plan, this.price );
    }
  }


  private luhnCheck(cardNumber:any) {
    // Build an array with the digits in the card number
    var digits = cardNumber.split('');
    for (var i = 0; i < digits.length; i++) {
      digits[i] = parseInt(digits[i], 10);
    }
    // Run the Luhn algorithm on the array
    var sum = 0;
    var alt = false;
    for (i = digits.length - 1; i >= 0; i--) {
      if (alt) {
        digits[i] *= 2;
        if (digits[i] > 9) {
          digits[i] -= 9;
        }
      }
      sum += digits[i];
      alt = !alt;
    }
    // Check the result
    if (sum % 10 == 0) {
      this.isCardNoValid = true;
    } else {
      this.isCardNoValid = false;
      console.log("luhn invalid.");
    }
  }

  public getCoupon(discountCoupon:string){
    this.isCouponValid = false;

    this.subscriptionsApi.couponsGet(this.authorization.getAccessToken(), discountCoupon).subscribe(
      (response:any) => {

        console.log("response ", response);
        this.discountCoupon = response.code;
        this.isCouponValid = true;
        this.price = Number(((1 - response.discount/100) * Number(this.plan.price)).toFixed(2));
        console.log("priceMultiplier ", this.price, this.plan)

      }, //Bind to view
      (err:any) => {
        // Log errors if any
        console.log(err);
        this.price = this.plan.price;
        this.isCouponValid = false;
        this.notificationService.displayError(err);
      });
  }


  public updateSubscription(formData:any){

    let expiryMonth:string = formData.mm;
    let expiryYear:string = "20" + formData.yy;

    this.subscriptionsApi.subscriptionsPut(this.authorization.getAccessToken(), formData.nameOnCard, formData.cardNo, expiryYear, expiryMonth, formData.cvc,
      formData.address, formData.zipCode, formData.city, formData.province, "TR",  formData.taxOffice, formData.taxNo, this.paymentGroup, formData.title, formData.name, formData.citizenId, formData.discountCoupon).subscribe(
      (response:any) => {

        console.log("response ", response);

        let content = response.response.htmlContent;

        var iframecontainer = document.getElementById("iframecontainer");

        iframecontainer.innerHTML ='<iframe id="threedsframe" width="80%" height="400px"></iframe>';
        var iframe:any = iframecontainer.childNodes[0];
        let doc =  iframe.contentDocument || iframe.contentWindow;
        doc.open();
        doc.write(content || response.response.errorMessage);
        doc.close();

        $("#modal_threeds").modal('show'); //open add modal

      }, //Bind to view
      (err:any) => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      });
  }


  public upgradeSubscription(formData:any){

    let expiryMonth:string = formData.mm;
    let expiryYear:string = "20" + formData.yy;

    let price:string = Number(this.price) || this.plan.price;
    console.log("price", price)
    this.subscriptionsApi.subscriptionsUpgradePut(this.authorization.getAccessToken(), this.plan.name, this.plan.period, String(price), formData.nameOnCard, formData.cardNo, expiryYear, expiryMonth, formData.cvc,
      formData.address, formData.zipCode, formData.city, formData.province, "TR",  formData.taxOffice, formData.taxNo, this.paymentGroup, formData.title, formData.name, formData.citizenId, this.discountCoupon).subscribe(
      (response:any) => {

        console.log("response ", response);

        let content = response.response.htmlContent;

        var iframecontainer = document.getElementById("iframecontainer");

        iframecontainer.innerHTML ='<iframe id="threedsframe" width="80%" height="400px"></iframe>';
        var iframe:any = iframecontainer.childNodes[0];
        let doc =  iframe.contentDocument || iframe.contentWindow;
        doc.open();
        doc.write(content || response.response.errorMessage);
        doc.close();

        $("#modal_threeds").modal('show'); //open add modal

      }, //Bind to view
      (err:any) => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      });
  }


  ngOnDestroy() {
    $('.modal-backdrop').remove(); //browser ileri-geri tuşuna basıncaki kırıklığı önlemek

    this.subscriptions.forEach(
      (s:Subscription) => s.unsubscribe()
    );
    if (this.timerSubscription != null) {
      this.timerSubscription.unsubscribe();
    }
  }
}
